const strings = {
  'dates/month/1/text': {
    en: 'Jan',
    fr: 'Janv.',
  },
  'dates/month/2/text': {
    en: 'Feb',
    fr: 'Févr.',
  },
  'dates/month/3/text': {
    en: 'Mar',
    fr: 'Mars',
  },
  'dates/month/4/text': {
    en: 'Apr',
    fr: 'Avr.',
  },
  'dates/month/5/text': {
    en: 'May',
    fr: 'Mai',
  },
  'dates/month/6/text': {
    en: 'June',
    fr: 'Juin',
  },
  'dates/month/7/text': {
    en: 'July',
    fr: 'Juil.',
  },
  'dates/month/8/text': {
    en: 'Aug',
    fr: 'Août',
  },
  'dates/month/9/text': {
    en: 'Sept',
    fr: 'Sept.',
  },
  'dates/month/10/text': {
    en: 'Oct',
    fr: 'Oct.',
  },
  'dates/month/11/text': {
    en: 'Nov',
    fr: 'Nov.',
  },
  'dates/month/12/text': {
    en: 'Dec',
    fr: 'Déc.',
  },
  'dates/yesterday/text': {
    en: 'Yesterday',
    fr: 'Hier',
  },
  'dates/today/text': {
    en: 'Today',
    fr: 'Aujourd’hui',
  },
};

export default strings;
